import React, { useEffect } from 'react'
import { IoIosClose } from 'react-icons/io'
import styled from 'styled-components'
import { colors, breakpoints } from '../utils/utils'
import useMobileDetect from 'use-mobile-detect-hook'
import useScrollBlock from '../hooks/useScrollBlock'

export default props => {

    const [ blockScroll, allowScroll ] = useScrollBlock()

    const detectMobile = useMobileDetect()
    
    useEffect(() => {
        // Search fix no allow scroll if navigate
        // if(menuOpen) {
        //     blockScroll()
        // }else{
        //     allowScroll()
        // }
    },[ detectMobile, blockScroll, allowScroll])

    
    
    return (
        < >
            <Overlay menuOpen={props.menuOpen} onClick={props.handleClickMenu}/>
            <Menu menuOpen={props.menuOpen}>
                <div>
                    <IoIosClose className="menu-close" onClick={props.handleClickMenu}/>
                    <ul>
                        {props.links}
                    </ul>
                </div>
                <ContactUs>
                    {props.contactUs}                
                </ContactUs>
            </Menu>            
        </>
    )

}
const ContactUs = styled.div`
    width: 100%;
    height: 6rem;
    background-color: ${colors.secondary};
    margin: 0;
    a {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        color: ${colors.quaternary};
        text-decoration: none;
        text-align: center;
        font-size: 1.8rem;
        &:hover {
            color: ${colors.primary};
        }
    }
`
const Overlay = styled.div`
    cursor: pointer;
    opacity: 1;
    height: 200%;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: unset;
    left: 0;
    display : ${ ({menuOpen}) => menuOpen ? 'block' : 'none' };
    z-index: 9999999998;
`

const Menu = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    transform: ${({menuOpen}) => menuOpen ? "translateX(0)" : "translateX(70vw)"};
    background: ${colors.senary};
    width: 70vw;
    height: 100vh;
    height: fill-available;
    z-index: 999999999999;
    transition: transform 0.5s;
    overflow:hidden;

    > div:first-of-type {
        display: flex;
        flex-direction: column;
        height: calc(100% - 6rem);
        padding: 1rem 4rem 4rem 4rem;
        overflow-y: auto;
        ${breakpoints.sm} {
            padding: 1rem 2rem 4rem 0;
        }
        .menu-close {
            align-self: flex-end;
            color: ${colors.secondary};
            font-size: 4rem;
            cursor: pointer;
            margin: 2rem -1rem 2rem 0;
        }
        li {
            padding-bottom: 2rem;
            text-align: right;
            a {
                display:block;
                transition: transform .5s;
                &:hover {
                    transform : translateY(-.5rem);
                }
                font-size: 1.8rem;
                text-decoration: none;
                color: ${colors.tertiary};

                &:hover {
                    color: ${colors.secondary};
                }        
            }
        }

    }

    .submenu-block a{
        margin:2rem 0 0;
        // font-size: 1.2rem!important;
    }

`
